import React, { Suspense } from 'react';
import { FaRegListAlt } from 'react-icons/fa';
import { Card, Tabs, LoadingSpinner } from 'components/common';
import ItemDimensionHeader from './item/ItemDimensionHeader';
import { getItemDimensions } from 'redux/erp/itemSlice';
import { useAgGrid } from 'hooks/useAgGrid';

const LazyItemList = React.lazy(() => import('./item/ItemDimensionList'));

const Items = () => {
  const {
    gridRef,
    gridApi,
    onGridReady,
    refreshGrid,
    updateRow,
    addRow,
    removeRow,
    clearAll,
    currentParams,
    updateCustomParams
  } = useAgGrid(getItemDimensions);

  return (
    <>
      <ItemDimensionHeader
        currentParams={currentParams}
        refreshGrid={refreshGrid}
        clearFilter={clearAll}
        addRow={addRow}
      />

      <Card padding="none">
        <Tabs
          variant="underline"
          lazyMount
          navClassName="tw-px-3 tw-pt-2 tw-bg-white"
          contentClassName="tw-bg-slate-50 tw-p-4"
          tabs={[
            {
              label: 'All',
              icon: <FaRegListAlt size={13} />,
              content: (
                <Suspense fallback={<LoadingSpinner message="Loading..." />}>
                  <LazyItemList
                    gridRef={gridRef}
                    gridApi={gridApi}
                    onGridReady={onGridReady}
                    updateRow={updateRow}
                    addRow={addRow}
                    removeRow={removeRow}
                    clearAll={clearAll}
                    refreshGrid={refreshGrid}
                    currentParams={currentParams}
                    updateCustomParams={updateCustomParams}
                  />
                </Suspense>
              ),
            },
          ]}
        />
      </Card>
    </>
  )
}

export default Items;
